import React from "react";
import "./Dashboard.css";
import ProgressCLBar from "../components/progressCLbar";
import Navigation from "../Navigation/Navigation";
import { clearAllNextLevel, getCurrentPathInfo, sequenceHandledListener } from "../SequenceHandler";
import SpinnerImage from "../LoanSpinner/LoanSpinner";
import CwsHeader from './../components/CwsHeader/CwsHeader.jsx';
import { isMobileNativeApp } from './../utils/mobileAppCheck';
import { getOfferPreFilledData } from "../selectors";
import { connect } from "react-redux";
import Toast from "../components/ToastAlert/Toast";
import { getHeaderStatus, isFAQShow, scrollToTop, updateLevel } from "../utils/is.after";
import { FAQList } from "../components/FAQ/FAQList";
import TopHeader from "../components/TopHeader/topHeader";
import { toggleConfig } from "../utils/toggleHelper";
import { isValidDigit } from "../utils/cl_apply_utility";
import SessionTimeout from "../components/SessionTimeOut/sessionTimeout";

const Dashboard = (props) =>{
  let toggleContainer, removeCardBackgroung, removeCardBorder;
  let step, removeBorderClass="", info, alert=props.offerPreFilled.showAlert;
  const activeSpinnerTemplate = props.offerPreFilled.spinnerToggle?<SpinnerImage />:null;
  const alertTemplate =alert.isError?<Toast alertType={alert.message.alertType} title={alert.message.heading} description={alert.message.desc} />:null;
  const headerDetails=props.offerPreFilled.cardDetails;
  const isHeaderShow=isMobileNativeApp()||getHeaderStatus(props.offerPreFilled.channelSource);
  const isFaqShow=isFAQShow(props.offerPreFilled.channelSource);
  const data=props.offerPreFilled.faq;
  const target=props.offerPreFilled.targetFlow;

  if(!window.isToggleOn){
    const securedFeatureToggles = toggleConfig();
    window.isToggleOn = securedFeatureToggles.isOn;
    window.isToggleOff = securedFeatureToggles.isOff;
  }

  const pendFlow =props.offerPreFilled.pendFlow;
  const isValidAmount = isValidDigit(props.offerPreFilled.offerDetails, "maxAmount");
  (()=>{
    if(target){
      updateLevel(target);
    }
    info = getCurrentPathInfo();
    if(info){
      step= info.step;
      removeBorderClass = info.removeBorder?"no-bottom-border":"";
      toggleContainer = info.toggleContainer?"container pend-flow-container":"container";
      removeCardBackgroung = info.removeCard? "no-card" : "card white-card";
      removeCardBorder = isHeaderShow? "tile-no-box-shadow":"";

    }
    clearAllNextLevel(info.level+1);
    sequenceHandledListener(info);
    scrollToTop();
  })();

  return (
    <section className="container-flud" id="dashboard-section">
      <SessionTimeout {...props} info={info}/>
      {activeSpinnerTemplate}
      {
        !isHeaderShow?
          <div>
            <TopHeader {...props} info={info}/>
            <CwsHeader />
          </div>
          :null
      }
      {alertTemplate}
      <div className={`${toggleContainer}`}>
        <div className="row justify-content-md-center">
          <div className="col col-lg-10 col-md-11 col-sm-12">
            <div className={`${removeCardBackgroung} ${removeCardBorder}`}>
              <div className={`card-header ${removeBorderClass}`}>
                <Navigation {...props} info={info}/>
              </div>
              <div className="card-body">
                {
                  (!pendFlow && isValidAmount && (step === 'miniApp')) ?<div className="top-header-show">
                    <h4 className="standard-blue offer_msg">
                      {`Congratulations, you've been approved for $${new Intl.NumberFormat().format(props.offerPreFilled.offerDetails.maxAmount)}.`}
                    </h4>
                  </div> : null
                }
                {
                  (step?<div className="row">
                    <div className="col-sm-2">&nbsp;</div>
                    <div className="col-sm text-center">
                      <ProgressCLBar step={step}/>
                    </div>
                    <div className="col-sm-2">&nbsp;</div>
                  </div>:null)
                }
                {props.children}
              </div>
            </div>
          </div>
        </div>
      </div>
      {
        isFaqShow?<FAQList faqs={data}
        />:null
      }
    </section>
  );
};
const mapStateToProps = (state) => {
  return { offerPreFilled: getOfferPreFilledData(state) };
};
export default connect(mapStateToProps, null)(Dashboard);
